module.exports = __webpack_public_path__ + "media/gallery_show-room.54b2a088.mp4";